import { Trans, useTranslation } from 'react-i18next';

const TermsAcceptanceControl = ({ checked, disabled, error, onChange }) => {
  const { t } = useTranslation();
  const errorId = 'terms-acceptance-error';

  return (
    <div className="web-modal-checkbox">
      <label>
        <input
          aria-label={t('accept_terms_checkbox_label', 'Accept Terms & Conditions')}
          aria-describedby={error ? errorId : undefined}
          checked={checked}
          disabled={disabled}
          name="acceptTerms"
          onChange={onChange}
          required
          type="checkbox"
        />
        <span className="web-modal-checkbox__text">
          <Trans
            i18nKey="accept_terms_and_conditions"
            defaults="I have read and accept the <termsLink>Terms & Conditions</termsLink>."
            components={{
              // Trans supplies the localized child text at runtime.
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              termsLink: <a href="/terms-and-conditions" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>,
            }}
          />
        </span>
      </label>
      {error && <p id={errorId} role="alert">{t(error, error)}</p>}
    </div>
  );
};

export default TermsAcceptanceControl;
